<template>
    <div class="news-detail-box">
        <detailItem v-if="id" :list="detailList"></detailItem>
    </div>
</template>
<script>
import detailItem from '../components/news-detail'
import { newsDetail } from './newsData'
export default {
    data () {
        return {
            id: '',
            newsDetail: newsDetail,
            detailList: []
        }
    },
    created () {
        this.id = this.$route.query.id
        this.detailList = this.newsDetail[this.id]
    },
    components: { detailItem }
}
</script>
<style lang="scss" scoped>
.news-detail-box{
    padding: 38px 20px 0px;
}
</style>